import reactDatePicker from "./react-datepicker";
import coloris from "./coloris";

export default `
  ${reactDatePicker}
  ${coloris}
`;
